module.exports = __webpack_public_path__ + "static/media/changePassword.228ebc5b.jpg";